import { FooterBottomDirective } from './bottom.directive';
import { FooterContentDirective } from './content.directive';

export const Directives = [
	FooterBottomDirective,
	FooterContentDirective,
];
